import React, { useState } from "react";

const Card = (props) => {
  const { movie } = props;
  return (
    <>
      <div className="card">
        <div className="image">
          <img
            src={
              movie.Poster != "N/A"
                ? movie.Poster
                : "https://placehold.co/230x200"
            }
            alt="Movie Image"
          />
        </div>
        <div className="description">
          <p>{movie.Title}</p>
          <span>{movie.Year}</span>
        </div>
      </div>
    </>
  );
};

export default Card;
